module.exports = __webpack_public_path__ + "static/media/techfy-single-logo.9bd5e5ad.png";